import { translate } from "@/lib/translations";

export function RoutePending() {
  const lang = typeof document !== "undefined" && document.documentElement.lang === "ar" ? "ar" : "en";

  return (
    <div className="mx-auto flex min-h-64 max-w-7xl items-center justify-center px-4" role="status">
      <p className="text-sm font-medium text-muted-foreground">{translate("common.loading", lang)}</p>
    </div>
  );
}
